<template>
  <div id="app">
    <!-- <loading ref="loading"/> -->
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"/>
    </transition>
  </div>
</template>

<script>
const requireContext = require.context("@/layouts", false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

import "@/assets/styles/main.css";
import config from "@/config";
import Loading from "@/components/Loading";
export default {
  name: "App",

  components: {
    Loading
  },

  data() {
    return {
      layout: null,
      defaultLayout: "default"
    };
  },

  metaInfo() {
    // const { appName } = window.config;
    return {
      title: process.env.APP_NAME,
      titleTemplate: `%s · ${process.env.APP_NAME}`
    };
  },

  mounted() {
    this.$loading = this.$refs.Loading;
  },

  methods: {
    /**
     * Set the application layout
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    }
  }
};
</script>

<style>
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue